import { render, staticRenderFns } from "./PriceConfigEdit.vue?vue&type=template&id=7e417440&"
import script from "./PriceConfigEdit.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports